export default __webpack_public_path__ + "static/media/ljsj.0e8fb54e.gif";